import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    height: '100%',
  },
  paper: {
    height: '100%',
  },
  paperGray: {
    height: '100%',
    backgroundColor: 'rgba(60, 65, 154, 0.05)',
  },
  commonTableContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    '& caption': {
      position: 'absolute',
      top: -200,
      right: -200,
    },
  },
  commonTableContainerPlaceholder: {
    '& input::placeholder': {
      color: 'white',
    },
  },
  tableContainer: {
    overflowX: 'initial',
    overflowY: 'auto',
    '&:focus-visible, &:focus': {
      outline: '3px solid grey',
    },
    scrollbarGutter: 'stable',
  },
  tableContainerNoOverflowInitial: {
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiTableCell-body': {
      cursor: 'default',
    },
  },

  bodyCellSelectionGray: {
    backgroundColor: 'rgba(60, 65, 154, 0.1)',
  },
  header: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '22px',
    lineHeight: '26px',
    margin: '0 0 20px',
  },
  pagination: {
    top: '60px',
  },
  hideRows: {
    color: 'rgba(60, 65, 154, 0.01)',
    borderBottom: '0px',
    backgroundColor: 'rgba(60, 65, 154, 0.05)',
  },
  headerCell: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '14px',
    color: 'rgba(44, 45, 62, 0.8)',
    background: '#ffffff',
    padding: '3px 20px 3px 4px',
    borderBottom: '1px solid rgba(44, 45, 62, 0.3)',
    height: 30,
    whiteSpace: 'nowrap',
    zIndex: 10,
    width: 'max-content',
    '&:focus-visible': {
      outline: '2px solid rgb(0, 0, 0)',
      outlineOffset: '-2px',
      zIndex: 110,
    },
    '&.MuiTableCell-root': {
      padding: '2px 5px 4px 5px',
    },
  },
  bodyCell: {
    fontFamily: 'Roboto',
    fontSize: '0.85rem',
    lineHeight: '14px',
    color: '#2C2D3E',
    padding: '2px 10px 2px 5px',
    borderBottom: '1px solid rgba(44, 45, 62, 0.3)',
    width: 'max-content',
    '& a': {
      color: '#3C419A',
      fontSize: '14px',
    },
    'td[tabindex="0"]&:focus': {
      outline: '2px solid rgb(0, 0, 0)',
      outlineOffset: '-2px',
      zIndex: 110,
      position: 'relative',
    },
    '&.MuiTableCell-root': {
      padding: '2px 5px 2px 5px',
    },
  },
  grayBodyCell: {
    fontFamily: 'Roboto',
    fontSize: '0.85rem',
    lineHeight: '14px',
    padding: '3px 16px 3px 10px',
    borderBottom: '0px',
  },
  bodyCellOdd: {
    background: 'rgba(202, 202, 252, 0.1)',
  },
  bodyCellSelected: {
    background: 'rgba(202, 202, 252, 0.7)',
  },
  bodyCellwithoutCheckboxes: {
    height: '42px',
  },
  checkbox: {
    padding: '9px 0',
  },
  isOnlineIcon: {
    position: 'relative',
    top: '-1px',
    width: '6px',
    height: '6px',
    marginRight: '5px',
    color: '#347F42',
  },
  isOfflineIcon: {
    position: 'relative',
    top: '-1px',
    width: '6px',
    height: '6px',
    marginRight: '5px',
    color: '#BC0000',
  },
  disabled: {
    pointerEvents: 'none',
    color: 'rgba(44, 45, 62, 0.5)',
    '& path': {
      fill: 'rgba(44, 45, 62, 0.5)',
    },
  },
  indeterminate: {
    '&$indeterminate': {
      color: '#3f51b5',
    },
  },
  indeterminateBlocked: {
    '&$indeterminate': {
      color: '#6F707B',
    },
  },
  examGroupHeaderStyle: {
    color: '#3C419A',
    fontWeight: 'bold',
  },
  bodyCellAnnotationsCheckboxes: {
    width: 10,
  },
}));
